module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.assessment.title))]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('div', [(_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "sample text-gray-500",
    class: [Number(_vm.count) === 0 ? 'opacity-50' : ''],
    attrs: {
      "disabled": Number(_vm.count) === 0
    },
    on: {
      "click": _vm.removePoint
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-left mr-1"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.count),
      expression: "count"
    }],
    staticClass: "w-12 h-8 rounded-md text-center bg-white border-solid border-gray-200 border outline-none",
    class: !_vm.hasTeacherPermissionsInCourse ? 'bg-gray-50' : 'bg-white',
    attrs: {
      "centeredText": true,
      "error": _vm.count === '',
      "disabled": !_vm.hasTeacherPermissionsInCourse ||
        _vm.$route.params.courseID === _vm.$store.state.course_sample_id
    },
    domProps: {
      "value": (_vm.count)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.count = $event.target.value
      }, _vm.inputed],
      "blur": _vm.saveAssessment
    }
  }), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "sample text-gray-500",
    class: [Number(_vm.count) === _vm.pointCap ? 'opacity-50' : ''],
    attrs: {
      "disabled": _vm.pointCap ? Number(_vm.count) === _vm.pointCap : false
    },
    on: {
      "click": _vm.addPoint
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-right ml-1"
  })]) : _vm._e()])]), _vm._v(" "), (!_vm.hasTeacherPermissionsInCourse && _vm.is_summary) ? _c('div', [_vm._v(_vm._s(_vm.count))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-50eb7f2e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/liveDiscussionPointComponent.vue
// module id = 1685
// module chunks = 61